export default [
  {
    header: 'Lotto',
    action: ['read'],
    resource: 'lotto',
  },
  {
    title: 'Lotto List',
    icon: 'ListIcon',
    route: 'lotto-list',
    action: ['read'],
    resource: 'lotto',
  },
  {
    title: 'Lotto Result',
    icon: 'EditIcon',
    route: 'lotto-result',
    action: ['read'],
    resource: 'lotto',
  },
  {
    title: 'Result History',
    icon: 'BookIcon',
    action: ['read'],
    resource: 'lotto',
    children: [
      {
        title: 'Lotto',
        route: 'lotto-history',
        action: ['read'],
        resource: 'lotto',
      },
      {
        title: 'Yeekee',
        route: 'yeekee-history',
        action: ['read'],
        resource: 'lotto',
      },
    ],
  },
]

// "Action": "read", "Subject": "lotto"
